/**
 * Return an object with axios methods for several urls
 * @param {Array<endpoint>} endpoints
 * @return Object
 */
export function buildServices (axiosInstance, endpoints = []) {
  return endpoints.reduce((acc, endpoint) => {
    acc[endpoint.name] = (...params) => {
      const uri = typeof endpoint.url === 'function'
        ? `${endpoint.url(...params)}`
        : `${endpoint.url}`
      const config = {
        method: endpoint.method,
        url: uri,
      }
      if (typeof endpoint.data === 'function') {
        config.data = endpoint.data(...params)
      } else if (params[0]) {
        config.data = params[0]
      }
      if (typeof endpoint.params === 'function') {
        config.params = endpoint.params(...params)
      } else if (endpoint.params) {
        config.params = endpoint.params
      }
      return axiosInstance(config)
        .then((response) => {
          return typeof endpoint.resolver === 'function' ? endpoint.resolver(response) :
            response.data ? response.data : response
        })
        .catch((error) => {
          throw error
        })
    }
    return acc
  }, {})
}